import React from 'react';
import { Fade } from '@mui/material';
import MaskSmall from './MaskSmall';
import MaskBig from './MaskBig';
import {
  AdminStar,
  AvatarContainer,
  AvatarImage,
  CustomizedToolTip,
  EditIcon,
  HoverMask,
  RootUserStar,
} from './Avatar.styles';

interface IAvatarProps {
  size: 'small' | 'large';
  background?: string;
  avatarBase64?: null | string | undefined | number | unknown | Record<string, unknown>;
  avatarUrl?: string;
  hoverMask?: boolean;
  adminStar?: boolean;
  className?: string;
  rootUserStar?: boolean;
  isMobile?: boolean;
}

const Avatar = (props: IAvatarProps) => {
  const {
    size,
    background = 'white',
    avatarBase64,
    avatarUrl,
    hoverMask,
    adminStar,
    rootUserStar,
    className,
    isMobile,
  } = props;

  const width = size === 'small' ? '46px' : '138px';
  const height = size === 'small' ? '47px' : '146px';
  const maskWidth = size === 'small' ? '56px' : '162px';
  const maskHeight = size === 'small' ? '56px' : '162px';
  const maskPositionTop = size === 'small' ? '-3px' : '-7px';
  const maskPositionLeft = size === 'small' ? '-5px' : '-12px';
  const isTooltip = adminStar || rootUserStar;

  const getToolTipText = (rootUserStar): string => {
    return rootUserStar ? 'Root User' : 'Admin User';
  };
  const tooltipText = isTooltip && getToolTipText(rootUserStar);

  return (
    <CustomizedToolTip
      style={{ background: 'red', position: 'relative' }}
      disableHoverListener={!isTooltip}
      title={tooltipText || ''}
      placement="right"
      TransitionComponent={Fade}
      TransitionProps={{ timeout: 300 }}>
      <AvatarContainer
        {...{
          width,
          height,
          maskWidth,
          maskHeight,
          maskPositionTop,
          maskPositionLeft,
          className,
        }}>
        <AvatarImage {...{ width, height, avatarBase64, avatarUrl }} />

        {/* Hover mask for edit user form (semitransparent background and edit icon) */}
        {hoverMask && (
          <HoverMask className="hover-mask">
            <EditIcon />
          </HoverMask>
        )}

        {/* Hexagon-shaped mask with borders and shadows */}
        {size === 'small' && <MaskSmall color={background} width={maskWidth} height={maskHeight} />}
        {size === 'large' && <MaskBig color={background} width={maskWidth} height={maskHeight} />}

        {size === 'small' && adminStar && <AdminStar />}
        {size === 'small' && rootUserStar && <RootUserStar />}
      </AvatarContainer>
    </CustomizedToolTip>
  );
};

export default Avatar;
